// if you change this, also change global.css
export const THEME = {
  light: {
    // TODO: add light theme colors (these are dark theme colors)
    background: 'hsl(0 0% 0%)', // background
    border: 'hsl(171 25.64% 15.29%)', // border
    card: 'hsl(180 11.76% 6.67%)', // card
    notification: 'hsl(0 84.2% 60.2%)', // destructive
    primary: 'hsl(172.8 80.65% 75.69%)', // primary
    text: 'hsl(172 78.95% 96.27%)' // foreground
  },
  dark: {
    background: 'hsl(0 0% 0%)', // background
    border: 'hsl(171 25.64% 15.29%)', // border
    card: 'hsl(180 11.76% 6.67%)', // card
    notification: 'hsl(0 84.2% 60.2%)', // destructive
    primary: 'hsl(172.8 80.65% 75.69%)', // primary
    text: 'hsl(172 78.95% 96.27%)' // foreground
  }
};
